import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  rating: {
    '& .MuiRating-icon': {
      color: colors.secondary,
    },
  },
  value: {
    marginLeft: 10,
    fontWeight: 'bold',
    fontSize: 13,
    lineHeight: 1.7,
    color: colors.secondary,
  },
});
